import { render, staticRenderFns } from "./auth-base-password-recover.vue?vue&type=template&id=328eb74c&scoped=true&"
import script from "./auth-base-password-recover.vue?vue&type=script&lang=ts&"
export * from "./auth-base-password-recover.vue?vue&type=script&lang=ts&"
import style0 from "./auth-base-password-recover.vue?vue&type=style&index=0&id=328eb74c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328eb74c",
  null
  
)

export default component.exports